import Vue from "vue";

const getDefaultState = () => {
  return {
    DotationsDeGroupe: [],
    DotationsDeregions: [],
    //field: "name",
    whereField: "responsable",
    //whereValue: "superviseur",
    collection: "dotationsDeGroupe",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.DotationsDeGroupe = payload;
  },
  SET_LISTE_DOTATION_DE_REGIONS(state, payload) {
    state.DotationsDeregions = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  ADD_ONE_ITEM(state, payload) {
    state.DotationsDeGroupe.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex Dotation de groupe", item)
  },
  async getDotationsDeregions({ commit }, arrayRegions) {
    let self = this;
    self._vm.$vloading.show();
    let DotationsDeregions = [];
    this._vm.$firebase
      .firestore()
      .collection("dotationsDeGroupe")
      .where("id_region", "in", arrayRegions)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          DotationsDeregions.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        commit("SET_LISTE_DOTATION_DE_REGIONS", DotationsDeregions);
        self._vm.$vloading.hide();
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  },
  async GetDotationsDuSuperviseur({ commit }, objet) {
    // start requête
    commit("SET_LISTE", []);
    commit("RESET_STATE");
    commit("Loading/START_BUSY_STATE", "DotationsDeGroupe GetAll", {
      root: true,
    });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.DotationsDeGroupe.collection)
      .where(this.state.FormationsDeGroupe.whereField, "==", objet.userId)
      .where('programmes_id_programme', "==", objet.project.id)
      .where("date_dotation", ">=", objet.start)
      .where("date_dotation", "<=", objet.end)
      .orderBy("date_dotation", "desc")
      .get()
      .then(
        (snapshot) => {
                snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "DotationsDeGroupe.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "DotationsDeGroupe.store.js", {
            root: true,
          });
        }
      );
  },
  async GetDotationsDeGroupe({ commit }, idGroupe) {
    // start requête
    commit("SET_LISTE", []);
    commit("RESET_STATE");
    commit("Loading/START_BUSY_STATE", "DotationsDeGroupe GetAll", {
      root: true,
    });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.DotationsDeGroupe.collection)
      .where("groupes_code_groupe", "==", idGroupe)
      .orderBy("date_dotation", "desc")
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", "DotationsDeGroupe GetAll", {
              root: true,
            });
          } else {
            console.log("tout est synchronisé Dans DotationsDeGroupe GetAll");
            commit("Pending/END_PENDING_STATE", "DotationsDeGroupe GetAll", {
              root: true,
            });
          }

          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "DotationsDeGroupe.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "DotationsDeGroupe.store.js", {
            root: true,
          });
        }
      );
  },
  async GetAll({ commit }) {
    // start requête
    commit("SET_LISTE", []);
    commit("RESET_STATE");
    commit("Loading/START_BUSY_STATE", "DotationsDeGroupe GetAll", {
      root: true,
    });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.DotationsDeGroupe.collection)
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", "DotationsDeGroupe GetAll", {
              root: true,
            });
          } else {
            console.log("tout est synchronisé Dans DotationsDeGroupe GetAll");
            commit("Pending/END_PENDING_STATE", "DotationsDeGroupe GetAll", {
              root: true,
            });
          }

          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "DotationsDeGroupe.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "DotationsDeGroupe.store.js", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  DotationsDeGroupe: (state) => {
    return state.DotationsDeGroupe;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
